import React from 'react';

import Dialog from './Dialog';
import Button from './Button';

function ConfirmDialog({title, description, ok = 'OK', cancel = 'Cancel', onOk, onCancel}) {
  return (
    <Dialog
      title={title}
      description={description}
      buttons={[
        <Button key="ok" autoFocus onClick={onOk}>{ok}</Button>,
        <Button key="cancel" secondary onClick={onCancel}>{cancel}</Button>
      ]}
    />
  );
}

export default ConfirmDialog;